import { Request } from './Request';

export interface IGetRemainingUserQuotaParams {
}

export interface IGetRemainingUserQuotaResult {
  usersRemaining?: number;
}

export class GetRemainingUserQuotaRequest extends Request<IGetRemainingUserQuotaParams, IGetRemainingUserQuotaResult> {
  constructor() {
    super('getRemainingUserQuota', {});
  }
}
